import { render, staticRenderFns } from "./beer-pack.vue?vue&type=template&id=4bb20df1"
import script from "./beer-pack.vue?vue&type=script&lang=js"
export * from "./beer-pack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports